/// <reference path="../types/index.d.ts" />

import '../client_forms/porter/style.css';
import FormStructure from './porter/form_structure';

export default FormStructure;